// src/docs/api/groups/suprimentosEndpoints.ts
import type { ApiEndpoint } from "../apiDocsSchema";

export const suprimentosEndpoints: ApiEndpoint[] = [
  {
    group: "Suprimentos",
    name: "Lista de Produtos",
    method: "GET",
    path: "/departamentos/suprimentos/produtos",
    authRequired: true,
    usageDescription:
      "Essa API é utilizada em https://${seuDominio}.com/${departamentoAcessado}/produtos, sendo essencial para receber os dados de cada produto registrado para o respectivo departamento.",

    responseDetails:
      "Retorna a fonte podendo ser banco (referente ao banco de dados) ou cache, e em data é retornado a lista de produtos cadastrados e seus dados correspondentes.",
    description:
      "Retorna a lista de produtos pertencentes ao departamento de suprimentos.",
    developed: true,

    params: [
      {
        name: "Authorization (enviado no cabeçalho/header)",
        in: "header",
        type: "string",
        required: true,
        description: "Sua chave de acesso Acess Token.",
        example: "28271737183818371738192912838bcbchhdh377ycbd6v6d7v6d6v7v7d8v",
        source: "Definido pelo próprio usuário no momento do cadastro.",
      },
    ],
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,

          fonte: "banco",
          versao: 1,
          data: [
            {
              codigo: "PRDZ024",
              ncm: "84433240",
              nome: "FURUNO IC - 120",
              classificacao: "ESTOQUE",
              posicao: "H1",
              ocultar: true,
              departamento: "suprimentos",
              empresa_id: "1",
              custo_unitario: "2500.00",
              moeda: "USD",
            },
          ],
        },
      },
    ],
  },

  {
    group: "Suprimentos",
    name: "Lista de Estoque",
    method: "GET",
    path: "/departamentos/suprimentos/estoque",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "nome",
        in: "body",
        type: "string",
        required: true,
        description: "Nome completo do usuário que será cadastrado.",
        example: "Fulano de Tal",
        source: "Definido pelo próprio usuário no momento do cadastro.",
      },
      {
        name: "email",
        in: "body",
        type: "string",
        required: true,
        description: "E-mail que será utilizado para acesso ao sistema.",
        example: "fulano@example.com",
        source:
          "Informado pelo usuário no formulário de cadastro; será usado depois no login.",
      },
      {
        name: "senha",
        in: "body",
        type: "string",
        required: true,
        description: "Senha que o usuário utilizará no login.",
        example: "SenhaForte123",
        source: "Definida pelo próprio usuário no momento do cadastro.",
      },
      {
        name: "código",
        in: "body",
        type: "int",
        required: true,
        description:
          "Código fornecido para vinculo ao departamento principal. Ex: 142569 = Financeiro",
        example: "145634",
        source:
          "Fornecido por um usuário Administrador (rotatividade a cada 3 dias)",
      },
    ],
    playgroundDefaults: {
      body: {
        nome: "Fulano de Tal",
        email: "fulano@example.com",
        senha: "SenhaForte123",
        codigo: 12345,
      },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Suprimentos",
    name: "Entradas no Estoque",
    method: "GET",
    path: "/departamentos/suprimentos/entradas",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Suprimentos",
    name: "Ajustes de Estoque",
    method: "GET",
    path: "/departamentos/suprimentos/ajustes",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Suprimentos",
    name: "Retornos ao Estoque",
    method: "GET",
    path: "/departamentos/suprimentos/retornos",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
];
